import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-search\">\n    <path stroke=\"currentColor\" stroke-width=\"2\" d=\"M17.645 10.2c0 3.963-3.264 7.2-7.322 7.2C6.263 17.4 3 14.163 3 10.2 3 6.238 6.264 3 10.322 3c4.059 0 7.323 3.238 7.323 7.2z\" />\n    <path fill=\"currentColor\" d=\"M20.287 21.702c.393.388 1.031.388 1.425 0 .393-.388.393-1.016 0-1.404l-1.425 1.404zm-4.993-4.92l4.993 4.92 1.425-1.404-4.994-4.92-1.425 1.404z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol